export default __webpack_public_path__ + "static/media/edit.8fc69e62.svg";